import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ.js';


class Cat extends XYZ {
  constructor(options) {
    options = options || {};
    const crossOrigin =
      options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';

    // const url =
    //   options.url !== undefined
    //     ? options.url
    //     : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
      const url = 'assets/i/{z}/{y}-{x}.png'
    super({
      attributions: "Kocia rekurencja. Zdięcia z pixelbay.com zaprogramowano przez Koliw",
      attributionsCollapsible : false,
      crossOrigin: crossOrigin,
      maxZoom: 5,
      minZoom: 1,
      opaque: true,
      url: url,
      zDirection: 100,
      wrapX: false,
    });
  }
}

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new Cat()
    })
  ],
  view: new View({
    center: [0, 0],
    zoom: 0
  })
});
